import axios from 'axios';
import {actions as A} from '../../constants/actions';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const getShumaStepStatus = ({shumaId, resetValues = true}) => dispatch => {
  dispatch({
    type: A.GET_SHUMA_STEPS_STATUS,
    payload: {resetValues}
  });

  const data = {shumaID: parseInt(shumaId, 10)};

  return axios.post(api.GET_SHUMA_STEPS_STATUS, data)
    .then(response => {
      const {body, errorCode} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      dispatch({
        type: A.GET_SHUMA_STEPS_STATUS_SUCCESS,
        payload: body.stepsStatus,
      });
    })
    .catch((err) => {
      dispatch({
        type: A.GET_SHUMA_STEPS_STATUS_FAILURE,
        payload: err.message
      })
    });
};
